import DialButton from './DialButton';

export default DialButton;
